import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import StyledMaterialIcon from './styles';

// Any numbers passed here will be multiplied by 1.5rem.
const sizeMap = {
  small: 0.8,
  medium: 1.4,
  large: 2
};
const Icon = ({
  color,
  size = 'medium',
  align,
  className,
  icon = '',
  title,
  display = 'inline',
  'aria-hidden': ariaHidden,
  ...props
}) => {
  const theme = useTheme();
  // aria-hidden should be defined only when title is not present and ariaHidden is true
  const ariaProps = title ? {
    title
  } : {
    'aria-hidden': Boolean(ariaHidden) || undefined
  };
  return /*#__PURE__*/React.createElement(StyledMaterialIcon, _extends({
    className: className,
    path: icon,
    role: "img",
    "data-align": align,
    color: theme.palette[color] || color,
    size: Number.isFinite(size) ? size : sizeMap[size] || size,
    $display: display
  }, ariaProps, props));
};
Icon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  display: PropTypes.string,
  'aria-hidden': PropTypes.bool
};
export default Icon;
//# sourceMappingURL=index.js.map